import {Table, Form, Space, Flex, App, Radio } from 'antd'
import React, { useEffect, useState } from 'react'
import CostCheck from '../../document/cost/CostCheck';
import Copy from '../../cpn/Copy';
import ReportCheck from '../../document/report/ReportCheck';
import classes from './costInvoice.module.css';
import StateTag from '../../cpn/StateTag';
import Icon from '../../cpn/Icon';
import CostInvoiceAdd from './CostInvoiceAdd';
import ClientSelect from '../../system/client/ClientSelect';
function InvoiceListCostList(props) {
    const { message } = App.useApp();
    const [form] = Form.useForm();
    const [list,setList] = useState([]);   
    const [query, setQuery] = useState({
      "ddzc_state": '',     
  });
    useEffect(() => {
        if (props.ddzcList) {
            let arr = props.ddzcList.filter((item) => (item.ddzc_state === '2' || item.ddzc_state === '3' || item.ddzc_state === '4' || item.ddzc_state === '5'));      
            if(query.ddzc_kh_id){
              arr = arr.filter((item) => item.ddzc_kh_id === query.ddzc_kh_id);
            }      
            if(query.ddzc_cbpdj_id==='1'){
                // 等于'1'，不过滤，不做任何处理
            }else if(query.ddzc_cbpdj_id==='2'){
                arr = arr.filter((item) => !item.ddzc_cbpdj_id);
            }else if(query.ddzc_cbpdj_id==='3'){
                arr = arr.filter((item) => item.ddzc_cbpdj_id);
            }
            arr = arr.map((item) => ({
                ...item,
                key: item.key || item.ddzc_id
            }));
            arr.sort((a, b) => new Date(b.ddzc_ctime) - new Date(a.ddzc_ctime));
            setList(arr);
        }
    }, [props.ddzcList, query.ddzc_kh_id, query.ddzc_cbpdj_id, props.yh_id])
    
    const columns = [    
        {
            title: '付款客户',
            dataIndex: 'ddsr_kh_name',
            width: '12%',
            key: 'ddsr_kh_name',         
            render: (text, record) =><CostCheck
                                        type='button'
                                        ddzc_id={record.key} 
                                        yh_id={props.yh_id}
                                        yh_name={props.yh_name}
                                        ddzc_bzd_id={record.ddzc_bzd_id}
                                        ddzc_price={record.ddzc_price}
                                        ddzc_content={record.ddzc_content}
                                        ddzc_date={record.ddzc_date}
                                        ddzc_date_end={record.ddzc_date_end}
                                        ddzc_bzd_name={record.ddzc_bzd_name}
                                        ddzc_bzd_danhao={record.ddzc_bzd_danhao}
                                        ddzc_type_id={record.ddzc_type_id}
                                        ddzc_type_name={record.ddzc_type_name}
                                        ddzc_kh_id={record.ddzc_kh_id}
                                        ddzc_kh_name={record.ddzc_kh_name}
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        ddzc_num={record.ddzc_num}
                                        ddzc_amount={record.ddzc_amount}
                                        ddzc_state={record.ddzc_state}
                                        ddzc_bm_id={record.ddzc_bm_id}
                                        ddzc_bm_name={record.ddzc_bm_name}
                                        ddzc_khyhzh_id={record.ddzc_khyhzh_id}
                                        ddzc_khyhzh_name={record.ddzc_khyhzh_name}
                                        ddzc_image_name={record.ddzc_image_name}
                                        ddzc_image_file={record.ddzc_image_file}
                                        ddzc_ctime={record.ddzc_ctime}
                                        ddzc_uid={record.ddzc_uid}
                                    />
        },
        {
            title: '付款金额',
            dataIndex: 'ddzc_amount',
            width: '10%',
            key: 'ddzc_amount',   
            render: (text, record) => <span style={{color:'green'}}>￥{Number(text).toLocaleString('zh-CN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}</span>
        },
        {
            title: '备注',
            dataIndex: 'ddzc_content',
            key:'ddzc_content',
            render:(text) => <Copy title={text}/>
        },   
        {
            title: '团队名称',
            width: '10%', 
            dataIndex:"ddzc_bzd_danhao",
            key:'ddzc_bzd_danhao',
            render:(text,record) => {
                return <ReportCheck  dsbzd_name={record.ddzc_bzd_name} dsbzd_id={record.ddzc_bzd_id} dsbzd_danhao={record.ddzc_bzd_danhao} yh_id={props.yh_id}  yh_name={props.yh_name} qy_id={props.qy_id} qy_name={props.qy_name}/>
            }
        },      
        {
            title: '开票',
            dataIndex: 'ddzc_cbpdj_id',
            width: '5%',
            key: 'ddzc_cbpdj_id',            
            render:(text) => text ? <span style={{color:'green'}}>已登记</span> : <span style={{color:'red'}}>未登记</span>
        },       
        {
            title: '状态',
            dataIndex: 'ddzc_state',
            width: '5%',
            key: 'ddzc_state',            
            render:(text) => <StateTag state={text} />
        },       
        {
            title: '编号',
            dataIndex: 'key',
            width: '5%',
            key: 'key',                        
        },       
    ]
    //多选
    //付款单id
    const [selectedddzc_id, setSelectedddzc_id] = useState([]);
    const [loading, setLoading] = useState(false);
    const start = () => {
        setLoading(true);
        // ajax request after empty completing
        setTimeout(() => {
            setSelectedddzc_id([]);
            setLoading(false);
        }, 1000);
    };
    //开票金额
    const [selectedddzc_amount, setSelectedddzc_amount] = useState(0);
    const onSelectChange = (newSelectedRowKeys, selectedRows) => {

        // 如果本次是添加而不是取消选择，需要验证客户一致性
        if (newSelectedRowKeys.length > selectedddzc_id.length) {
            // 新增的key
            const addedKey = newSelectedRowKeys.find(key => !selectedddzc_id.includes(key));
            const addedRow = selectedRows.find(row => row.key === addedKey);
            // 找到当前已选首个的客户ID
            let commonKhId = undefined;
            if (selectedRows.length > 1) {
                // 当前已勾选的客户id
                // 通常 selectedRows 顺序和 newSelectedRowKeys 一致
                for (let row of selectedRows) {
                    if (row.key !== addedKey) {
                        commonKhId = row.ddzc_kh_id;
                        break;
                    }
                }
            }
            // 如果全部uncheck后再check，commonKhId也可能是undefined
            // 首次选取则允许
            if (commonKhId !== undefined && addedRow && addedRow.ddzc_kh_id !== commonKhId) {
                message.warning('只能选择同一个客户的付款单！');
                // 直接return，不更新
                return;
            }
        }
        setSelectedddzc_amount(selectedRows.reduce((sum, row) => sum + Number(row.ddzc_amount || 0), 0));
        setSelectedddzc_id(newSelectedRowKeys);
    }
    // 记录所选客户的id和name，传递下去
    const [selectedddzc_kh_id, setSelectedddzc_kh_id] = useState('');
    const [selectedddzc_kh_name, setSelectedddzc_kh_name] = useState('');

    useEffect(() => {
        // 根据已选的 selectedddzc_id，查找客户id与name（如果有选中的付款单）
        if (selectedddzc_id.length === 0) {
            setSelectedddzc_kh_id('');
            setSelectedddzc_kh_name('');
        } else {
            const selectedRow = list.find(item => item.key === selectedddzc_id[0]);
            if (selectedRow) {
                setSelectedddzc_kh_id(selectedRow.ddzc_kh_id || '');
                setSelectedddzc_kh_name(selectedRow.ddzc_kh_name || '');
            }
        }
    }, [selectedddzc_id, list]);
    const rowSelection = {
        selectedRowKeys: selectedddzc_id,
        onChange: onSelectChange,
        getCheckboxProps: (record) => ({
            disabled: !!record.ddzc_cbpdj_id, // ddsr_cbpdj_id 有值不能选
        }),
    };
    const hasSelected = selectedddzc_id.length > 0;
    return (
        <>                            
            <Flex style={{ marginBottom: "10px" }} align='center' justify='space-between'>
                <Form
                    layout='inline'
                    name='form_cost_invoice_cost_list'
                    form={form}
                    initialValues={{                        
                        ddzc_state: query.ddzc_state ? query.ddzc_state : '',                        
                    }}
                    onFinish={(values) => {
                        console.log(values);
                        // Serialize dayjs objects to strings before storing
                        const serializedValues = {
                            ...values,
                            
                            ddzc_kh_id: values.ddzc_kh_id ? values.ddzc_kh_id : '',
                        };
                        
                            localStorage.setItem('jtg-caiwu_incomeList_ddzc_kh_id', JSON.stringify(serializedValues.ddzc_kh_id));
                        setQuery(prev => ({ 
                            ...prev, 
                            dsbzd_state: serializedValues.dsbzd_state, 
                        }));
                    }}
                >
                    <ClientSelect
                        onChange={(value) => {
                            setQuery(prev => ({ 
                                ...prev, 
                                ddzc_kh_id: value,                                     
                            }));
                            localStorage.setItem('jtg-caiwu_incomeList_ddzc_kh_id', JSON.stringify(value));
                        }}
                        qy_id={props.qy_id}
                        qy_name={props.qy_name}
                        yh_id={props.yh_id}
                        yh_name={props.yh_name}
                        style={{width:'250px'}}
                        placeholder='选择付款客户'
                        name='ddzc_kh_id'
                    />                   
                    <Form.Item name='ddzc_cbpdj_id'>
                        <Radio.Group
                            onChange={(e) => {
                               setQuery(prev => ({ 
                                ...prev, 
                                ddzc_cbpdj_id: e.target.value,                                     
                                }));
                            }}
                        >
                            <Radio value='1'>全部</Radio>
                            <Radio value='2'>未登记</Radio>
                            <Radio value='3'>已登记</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item style={{marginLeft: 10}}>
                        <Space align='center' size='middle'>                           
                            <Icon type='reset'
                                onClick={() => {
                                    form.resetFields()
                                    localStorage.setItem('jtg-caiwu_incomeList_ddzc_kh_id', JSON.stringify(''))
                                    setQuery({
                                        "ddzc_kh_id": '',                                        
                                        "ddzc_cbpdj_id": '1',
                                    })
                                    form.setFieldsValue({
                                        ddzc_kh_id: null,
                                        ddzc_cbpdj_id: '1',
                                    });
                                }}
                            />
                        </Space>
                    </Form.Item>
                </Form> 
                <Flex align="center" gap="middle">
                    {hasSelected ? `已选择 ${selectedddzc_id.length} 条付款单，总金额：￥${Number(selectedddzc_amount).toLocaleString('zh-CN', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    })}` : ''}    
                    <CostInvoiceAdd 
                        selectedddzc_id={selectedddzc_id}
                        qy_id={props.qy_id}
                        qy_name={props.qy_name}
                        yh_id={props.yh_id}
                        yh_name={props.yh_name}
                        selectedddzc_amount={selectedddzc_amount}
                        selectedddzc_kh_id={selectedddzc_kh_id}
                        selectedddzc_kh_name={selectedddzc_kh_name}
                        onReset={start}
                    />                
                    <Icon 
                        type="reset" 
                        onClick={start} 
                        disabled={!hasSelected} 
                        loading={loading}
                    />
                </Flex> 
            </Flex>
            <Table 
                className={classes.greenHeader}
                dataSource={list}
                columns={columns}
                pagination={false}
                size='small'
                bordered
                rowKey="key"
                summary={pageData => {
                    const total = pageData.reduce((sum, row) => sum + Number(row.ddzc_amount || 0), 0);
                    return (
                        <Table.Summary.Row>
                            <Table.Summary.Cell key="summary-0" index={0}></Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-1" index={1}></Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-2" index={2} colSpan={1}>
                                <span style={{color:'green'}}>合计：￥{Number(total).toLocaleString('zh-CN', {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            })}</span>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-3" index={3} colSpan={columns.length - 2} />
                        </Table.Summary.Row>
                    );
                }}
                locale={{
                    emptyText: '暂无付款数据' // This will display text when the table is empty
                }}
                rowSelection={rowSelection}
            />
        </>
    )
}

export default InvoiceListCostList